"use client";

import { c as _c } from "react/compiler-runtime";
import { useEnsResolution } from "@/hooks/useEnsResolution";
import { DELEGATION_ALL_ADDRESS, DELEGATION_CONTRACT } from "@/constants";
import { getRandomObjectId } from "@/helpers/AllowlistToolHelpers";
import { areEqualAddresses, getTransactionLink } from "@/helpers/Helpers";
import { faInfoCircle, faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useEffectEvent, useState } from "react";
import { Col, Container, Form, Row } from "react-bootstrap";
import { Tooltip } from "react-tooltip";
import { useEnsName, useWaitForTransactionReceipt, useWriteContract } from "wagmi";
import { DelegationCollection, SUPPORTED_COLLECTIONS } from "./delegation-constants";
import { useOrignalDelegatorEnsResolution } from "./delegation-shared";
import styles from "./Delegation.module.scss";
function DelegationAddressInput(props) {
  const $ = _c(10);
  const {
    setAddress
  } = props;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      chainId: 1
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    inputValue,
    address,
    handleInputChange
  } = useEnsResolution(t0);
  let t1;
  let t2;
  if ($[1] !== address || $[2] !== setAddress) {
    t1 = () => {
      setAddress(address);
    };
    t2 = [setAddress, address];
    $[1] = address;
    $[2] = setAddress;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  let t3;
  if ($[5] !== handleInputChange) {
    t3 = e => {
      handleInputChange(e.target.value);
    };
    $[5] = handleInputChange;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== inputValue || $[8] !== t3) {
    t4 = <Form.Control placeholder="0x... or ENS" className={`${styles.formInput}`} type="text" value={inputValue} onChange={t3} />;
    $[7] = inputValue;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
}
export function DelegationFormLabel(props) {
  const $ = _c(14);
  let t0;
  if ($[0] !== props.title) {
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = /\s+/g;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    t0 = props.title.toLowerCase().replace(t1, "-");
    $[0] = props.title;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const tooltipId = `delegation-form-label-${t0}`;
  const t1 = props.span ?? 3;
  let t2;
  if ($[3] !== tooltipId) {
    t2 = <FontAwesomeIcon className={styles.infoIcon} icon={faInfoCircle} data-tooltip-id={tooltipId} />;
    $[3] = tooltipId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    };
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props.tooltip || $[7] !== tooltipId) {
    t4 = <Tooltip id={tooltipId} place="top" style={t3}>{props.tooltip}</Tooltip>;
    $[6] = props.tooltip;
    $[7] = tooltipId;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== props.title || $[10] !== t1 || $[11] !== t2 || $[12] !== t4) {
    t5 = <Form.Label column={true} sm={t1} className="d-flex align-items-center">{props.title}{t2}{t4}</Form.Label>;
    $[9] = props.title;
    $[10] = t1;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}
export function DelegationFormOriginalDelegatorFormGroup(props) {
  const $ = _c(5);
  let t0;
  if ($[0] !== props.subdelegation) {
    t0 = {
      subdelegation: props.subdelegation
    };
    $[0] = props.subdelegation;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const orignalDelegatorEnsResolution = useOrignalDelegatorEnsResolution(t0);
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <DelegationFormLabel title="Original Delegator" tooltip="Original Delegator of Sub Delegation - The address the delegation will be registed for" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = orignalDelegatorEnsResolution.data ? `${orignalDelegatorEnsResolution.data} - ${props.subdelegation.originalDelegator}` : `${props.subdelegation.originalDelegator}`;
  let t3;
  if ($[3] !== t2) {
    t3 = <Form.Group as={Row} className="pb-4">{t1}<Col sm={9}><Form.Control className={`${styles.formInput} ${styles.formInputDisabled}`} type="text" value={t2} disabled={true} /></Col></Form.Group>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
export function DelegationAddressDisabledInput(props) {
  const $ = _c(2);
  const t0 = props.ens ? `${props.ens} - ${props.address}` : `${props.address}`;
  let t1;
  if ($[0] !== t0) {
    t1 = <Form.Control className={`${styles.formInput} ${styles.formInputDisabled}`} type="text" value={t0} disabled={true} />;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}
function DelegationAddressDisplay(props) {
  const $ = _c(5);
  const t0 = props.address as `0x${string}`;
  let t1;
  if ($[0] !== t0) {
    t1 = {
      address: t0,
      chainId: 1
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const ens = useEnsName(t1);
  const t2 = ens.data && ` - ${ens.data}`;
  let t3;
  if ($[2] !== props.address || $[3] !== t2) {
    t3 = <>{props.address}{t2}</>;
    $[2] = props.address;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
export function DelegationFormOptionsFormGroup(props) {
  const $ = _c(15);
  let t0;
  if ($[0] !== props.title || $[1] !== props.tooltip) {
    t0 = <DelegationFormLabel title={props.title} tooltip={props.tooltip} />;
    $[0] = props.title;
    $[1] = props.tooltip;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const t1 = props.selected;
  let t2;
  if ($[3] !== props) {
    t2 = e => props.setSelected(e.target.value);
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <option value="" disabled={true}>Select</option>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props.options) {
    t4 = props.options.map(_temp);
    $[6] = props.options;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== props.selected || $[9] !== t2 || $[10] !== t4) {
    t5 = <Col sm={9}><Form.Select className={`${styles.formInput}`} value={t1} onChange={t2}>{t3}{t4}</Form.Select></Col>;
    $[8] = props.selected;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t0 || $[13] !== t5) {
    t6 = <Form.Group as={Row} className="pb-4">{t0}{t5}</Form.Group>;
    $[12] = t0;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}
function _temp(o) {
  return <option key={o} value={o}><DelegationAddressDisplay address={o} /></option>;
}
export function DelegationFormCollectionFormGroup(props) {
  const $ = _c(33);
  let T0;
  let T1;
  let T2;
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[0] !== props) {
    const collections = !props.subdelegation || areEqualAddresses(props.subdelegation.collection.contract, DELEGATION_ALL_ADDRESS) ? SUPPORTED_COLLECTIONS : [props.subdelegation.collection];
    T2 = Form.Group;
    t6 = Row;
    t7 = "pb-4";
    const t9 = `Collection address for ${props.consolidation ? "consolidation" : "delegation"}`;
    if ($[13] !== t9) {
      t8 = <DelegationFormLabel title="Collection" tooltip={t9} />;
      $[13] = t9;
      $[14] = t8;
    } else {
      t8 = $[14];
    }
    T1 = Col;
    t5 = 9;
    T0 = Form.Select;
    t0 = `${styles.formInput}`;
    t1 = props.collection;
    t2 = e => props.setCollection(e.target.value);
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <option value="0" disabled={true}>Select Collection</option>;
      $[15] = t3;
    } else {
      t3 = $[15];
    }
    t4 = collections.map(_temp2);
    $[0] = props;
    $[1] = T0;
    $[2] = T1;
    $[3] = T2;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    T0 = $[1];
    T1 = $[2];
    T2 = $[3];
    t0 = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
    t8 = $[12];
  }
  let t9;
  if ($[16] !== T0 || $[17] !== t0 || $[18] !== t1 || $[19] !== t2 || $[20] !== t3 || $[21] !== t4) {
    t9 = <T0 className={t0} value={t1} onChange={t2}>{t3}{t4}</T0>;
    $[16] = T0;
    $[17] = t0;
    $[18] = t1;
    $[19] = t2;
    $[20] = t3;
    $[21] = t4;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== T1 || $[24] !== t5 || $[25] !== t9) {
    t10 = <T1 sm={t5}>{t9}</T1>;
    $[23] = T1;
    $[24] = t5;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== T2 || $[28] !== t10 || $[29] !== t6 || $[30] !== t7 || $[31] !== t8) {
    t11 = <T2 as={t6} className={t7}>{t8}{t10}</T2>;
    $[27] = T2;
    $[28] = t10;
    $[29] = t6;
    $[30] = t7;
    $[31] = t8;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  return t11;
}
function _temp2(sc) {
  return <option key={`add-delegation-select-collection-${sc.contract}`} value={sc.contract}>{`${sc.display}`}</option>;
}
export function DelegationFormDelegateAddressFormGroup(props) {
  const $ = _c(8);
  let t0;
  if ($[0] !== props.title || $[1] !== props.tooltip) {
    t0 = <DelegationFormLabel title={props.title} tooltip={props.tooltip} />;
    $[0] = props.title;
    $[1] = props.tooltip;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== props) {
    t1 = <Col sm={9}><DelegationAddressInput setAddress={address => props.setAddress(address)} /></Col>;
    $[3] = props;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t0 || $[6] !== t1) {
    t2 = <Form.Group as={Row} className="pb-4">{t0}{t1}</Form.Group>;
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
export function DelegationSubmitGroups(props) {
  const $ = _c(49);
  const {
    title,
    writeParams,
    showCancel,
    gasError,
    validate,
    onHide,
    onSetToast,
    submitBtnLabel
  } = props;
  const writeDelegation = useWriteContract();
  let t0;
  if ($[0] !== writeDelegation.data) {
    t0 = {
      confirmations: 1,
      hash: writeDelegation.data
    };
    $[0] = writeDelegation.data;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const waitWriteDelegation = useWaitForTransactionReceipt(t0);
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const [errors, setErrors] = useState(t1);
  let t2;
  if ($[3] !== onSetToast) {
    t2 = toast => {
      onSetToast(toast);
    };
    $[3] = onSetToast;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const emitToast = useEffectEvent(t2);
  let t3;
  if ($[5] !== gasError || $[6] !== onSetToast || $[7] !== title || $[8] !== validate || $[9] !== writeDelegation || $[10] !== writeParams) {
    t3 = function submitDelegation() {
      const newErrors = validate();
      if (newErrors.length > 0 || gasError) {
        setErrors(newErrors);
        window.scrollBy(0, 100);
      } else {
        writeDelegation.writeContract(writeParams);
        onSetToast({
          title,
          message: "Confirm in your wallet..."
        });
      }
    };
    $[5] = gasError;
    $[6] = onSetToast;
    $[7] = title;
    $[8] = validate;
    $[9] = writeDelegation;
    $[10] = writeParams;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  const submitDelegation = t3;
  let t4;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = function getTransactionAnchor(hash) {
      return `<a href=${getTransactionLink(DELEGATION_CONTRACT.chain_id, hash)}
    target="_blank"
    rel="noopener noreferrer"
    className=${styles.etherscanLink}>
      view
    </a>`;
    };
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const getTransactionAnchor = t4;
  let t5;
  if ($[13] !== emitToast || $[14] !== title || $[15] !== waitWriteDelegation.isLoading || $[16] !== writeDelegation.data || $[17] !== writeDelegation.error) {
    t5 = () => {
      if (writeDelegation.error) {
        emitToast({
          title,
          message: writeDelegation.error.message.split("Request Arguments")[0]
        });
      }
      if (writeDelegation.data) {
        if (waitWriteDelegation.isLoading) {
          emitToast({
            title,
            message: `Transaction submitted...
                    ${getTransactionAnchor(writeDelegation.data)}
                    <br />Waiting for confirmation...`
          });
        } else {
          emitToast({
            title,
            message: `Transaction Successful!
                    ${getTransactionAnchor(writeDelegation.data)}`
          });
        }
      }
    };
    $[13] = emitToast;
    $[14] = title;
    $[15] = waitWriteDelegation.isLoading;
    $[16] = writeDelegation.data;
    $[17] = writeDelegation.error;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== title || $[20] !== waitWriteDelegation.isLoading || $[21] !== writeDelegation.data || $[22] !== writeDelegation.error) {
    t6 = [writeDelegation.error, writeDelegation.data, waitWriteDelegation.isLoading, title];
    $[19] = title;
    $[20] = waitWriteDelegation.isLoading;
    $[21] = writeDelegation.data;
    $[22] = writeDelegation.error;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  useEffect(t5, t6);
  let t7;
  if ($[24] !== waitWriteDelegation.isLoading || $[25] !== writeDelegation.isPending) {
    t7 = function isLoading() {
      return writeDelegation.isPending || waitWriteDelegation.isLoading;
    };
    $[24] = waitWriteDelegation.isLoading;
    $[25] = writeDelegation.isPending;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  const isLoading = t7;
  let t8;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Form.Label column={true} sm={4} className="d-flex align-items-center" />;
    $[27] = t8;
  } else {
    t8 = $[27];
  }
  let t9;
  if ($[28] !== onHide || $[29] !== showCancel) {
    t9 = showCancel && <button className={styles.newDelegationCancelBtn} onClick={() => onHide()}>Cancel</button>;
    $[28] = onHide;
    $[29] = showCancel;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  const t10 = `${styles.newDelegationSubmitBtn} ${isLoading() ? `${styles.newDelegationSubmitBtnDisabled}` : ""}`;
  let t11;
  if ($[31] !== submitDelegation) {
    t11 = e => {
      e.preventDefault();
      submitDelegation();
    };
    $[31] = submitDelegation;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  const t12 = submitBtnLabel ?? "Submit";
  let t13;
  if ($[33] !== isLoading) {
    t13 = isLoading() && <div className="d-inline"><output className={`spinner-border ${styles.loader}`}><span className="sr-only" /></output></div>;
    $[33] = isLoading;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== t10 || $[36] !== t11 || $[37] !== t12 || $[38] !== t13) {
    t14 = <button className={t10} onClick={t11}>{t12}{" "}{t13}</button>;
    $[35] = t10;
    $[36] = t11;
    $[37] = t12;
    $[38] = t13;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  let t15;
  if ($[40] !== t14 || $[41] !== t9) {
    t15 = <Form.Group as={Row} className="pt-2 pb-4">{t8}<Col sm={8} className="d-flex align-items-center justify-content-center">{t9}{t14}</Col></Form.Group>;
    $[40] = t14;
    $[41] = t9;
    $[42] = t15;
  } else {
    t15 = $[42];
  }
  let t16;
  if ($[43] !== errors || $[44] !== gasError) {
    t16 = (errors.length > 0 || gasError) && <Form.Group as={Row} className={`pt-2 pb-2 ${styles.newDelegationError}`}><Form.Label column={true} sm={4} className="d-flex align-items-center">Errors</Form.Label><Col sm={8} className="d-flex align-items-center"><ul className="mb-0">{errors.map(_temp3)}{gasError && <li>{gasError}</li>}</ul></Col></Form.Group>;
    $[43] = errors;
    $[44] = gasError;
    $[45] = t16;
  } else {
    t16 = $[45];
  }
  let t17;
  if ($[46] !== t15 || $[47] !== t16) {
    t17 = <>{t15}{t16}</>;
    $[46] = t15;
    $[47] = t16;
    $[48] = t17;
  } else {
    t17 = $[48];
  }
  return t17;
}
function _temp3(e_0) {
  return <li key={getRandomObjectId()}>{e_0}</li>;
}
export function DelegationExpiryCalendar(props) {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = new Date().toISOString().slice(0, 10);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <Container fluid={true} className="no-padding pt-3"><Row><Col xs={12} xm={12} md={6} lg={4}><Form.Control min={t0} className={`${styles.formInput}`} type="date" placeholder="Expiry Date" onChange={e => {
            const value = e.target.value;
            if (value) {
              props.setDelegationDate(new Date(value));
            } else {
              props.setDelegationDate(undefined);
            }
          }} /></Col></Row></Container>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}
export function DelegationTokenSelection(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <Container fluid={true} className="no-padding pt-3"><Row><Col xs={12} xm={12} md={6} lg={4}><Form.Control min={0} className={`${styles.formInput}`} type="number" placeholder="Token ID" onChange={e => {
            const value = e.target.value;
            try {
              const intValue = parseInt(value);
              props.setDelegationToken(intValue);
            } catch {
              props.setDelegationToken(undefined);
            }
          }} /></Col></Row></Container>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export function DelegationCloseButton(props) {
  const $ = _c(16);
  let t0;
  if ($[0] !== props.title) {
    let t1;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = /\s+/g;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    t0 = props.title.toLowerCase().replace(t1, "-");
    $[0] = props.title;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const tooltipId = `delegation-close-button-${t0}`;
  const t1 = `Cancel ${props.title}`;
  let t2;
  if ($[3] !== props) {
    t2 = () => props.onHide();
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2 || $[7] !== tooltipId) {
    t3 = <FontAwesomeIcon aria-label={t1} className={styles.closeNewDelegationForm} icon={faTimesCircle} onClick={t2} data-tooltip-id={tooltipId} />;
    $[5] = t1;
    $[6] = t2;
    $[7] = tooltipId;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px"
    };
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = `Cancel ${props.title}`;
  let t6;
  if ($[10] !== t5 || $[11] !== tooltipId) {
    t6 = <Tooltip id={tooltipId} place="top" delayShow={250} style={t4}>{t5}</Tooltip>;
    $[10] = t5;
    $[11] = tooltipId;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t3 || $[14] !== t6) {
    t7 = <>{t3}{t6}</>;
    $[13] = t3;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}